module.exports = __webpack_public_path__ + "static/media/__Social-3.61e00707.svg";